export const CSR = 'CSR'
export const CRR = 'CRR'
export const FOS_LIQ = 'fos_liq'
export const S = 's'
export const CONE_RESISTANCE = 'cone_resistance'
export const LPI = 'LPI'
export const LDI = 'LDI'
export const LSN = 'LSN'
export const PL = 'PL'
